import React from "react";
import { Flex } from "@fluentui/react-northstar";
import BreadcrumbFolders from "../../components/breadcrumb/BreadcrumbFolders";
import { DateRangePickerOneMonth } from "../../../../components/DateRangePicker/DateRangePickerOneMonth";
import { _api_get_documents_hr } from "../../api/index.hr";
import useLogicDocumentsHr from "../../hooks/useLogicDocumentsHr";
import {
    ButtonReset,
    DropdownFilter,
    TableFiles,
} from "../../styles/index.styles";
import BarTools from "../../components/toolbar/BarTools";
import DialogAddDocument from "../../components/DialogAddDocument/DialogAddDocument";

const HrDocumentsFolders = () => {
    const { functions, table, breadcrumb, toolbar, query, filter } =
        useLogicDocumentsHr();

    return (
        <Flex column gap="gap.medium" fill>
            {/* breadcrumb */}
            <Flex gap="gap.small" space="between">
                <BreadcrumbFolders
                    breadcrumb={breadcrumb}
                    onClickBreadcrumbItem={functions.handleBreadcrumbItemClick}
                />
                {/* ajouter un document */}
                <DialogAddDocument
                    onSuccess={() => {
                        return functions.refetch();
                    }}
                />
            </Flex>
            {/* filters */}
            <Flex gap="gap.medium">
                <Flex>
                    <DropdownFilter
                        placeholder="Personne ou département"
                        items={filter.user_departments.data}
                        onChange={filter.onChangeUsersDepartments}
                        value={
                            filter.usersState?.length > 0
                                ? filter.usersState
                                : filter.user_departments.data.filter(
                                      (option) =>
                                          filter.defaultSelectedUsers.includes(
                                              option.key
                                          )
                                  ) ?? []
                        }
                        search
                        multiple
                        inverted
                    />
                </Flex>
                <Flex>
                    <DateRangePickerOneMonth
                        defaultStartDate={filter.searchParams.get("sd")}
                        defaultEndDate={filter.searchParams.get("ed")}
                        resetDatesToNull={filter.resetDatesToNull}
                        onDatesChange={filter.onDatesChange}
                    />
                </Flex>
                <Flex>
                    <DropdownFilter
                        className="category"
                        placeholder="Choisir une catégorie"
                        items={filter.categories_folder.data}
                        onChange={filter.onChangeCategories}
                        value={
                            filter.categoriesState?.length > 0
                                ? filter.categoriesState
                                : filter.categories_folder.data.filter(
                                      (option) =>
                                          filter.defaultCategorie.includes(
                                              option.key
                                          )
                                  ) ?? []
                        }
                        multiple
                        inverted
                        fluid
                        search
                    />
                </Flex>
                <div>
                    <ButtonReset
                        className={
                            filter.disable_reset_button ? "disabled" : ""
                        }
                        disabled={filter.disable_reset_button}
                        onClick={() => {
                            filter.setResetDatesToNull(new Date().getTime());
                            return filter.setSearchParams();
                        }}
                        text
                    >
                        Réinitialiser les filtres
                    </ButtonReset>
                </div>
            </Flex>
            {/* tableau */}
            <Flex
                fill
                column
                styles={{
                    position: "relative",
                    minHeight: "400px",
                }}
            >
                <TableFiles
                    variables={{
                        cellContentOverflow: "none",
                    }}
                    header={
                        query.isLoading || query.isFetching
                            ? table.skeleton_header
                            : table.header
                    }
                    rows={
                        query.isLoading || query.isFetching
                            ? table.skeleton
                            : table.rows
                    }
                />
                {/* selections + download + delete items */}
                {toolbar.show && (
                    <BarTools
                        counterSelection={toolbar.counter}
                        disableDelete={toolbar.disableDelete}
                        isDownloading={toolbar.isDownloadingDocumentMultiple}
                        isDeleting={toolbar.isDeletingDocumentMultiple}
                        onClickDeleteMultiple={
                            toolbar.mutateDeleteDocumentMultiple
                        }
                        onClickDownloadMultiple={
                            toolbar.mutateDownloadDocumentMultiple
                        }
                        onReset={() => functions.handleCheckAll(false)}
                    />
                )}
            </Flex>
        </Flex>
    );
};

export default HrDocumentsFolders;
